var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "Polaris-DescriptionList"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('dt', {
      staticClass: "Polaris-DescriptionList__Term"
    }, [_vm._v("\n            " + _vm._s(item.term) + "\n        ")]), _vm._v(" "), _c('dd', {
      staticClass: "Polaris-DescriptionList__Description"
    }, [_vm._v("\n            " + _vm._s(item.description) + "\n        ")])]
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d7f6f5aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7f6f5aa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisDescriptionList.vue
// module id = 327
// module chunks = 0